import actionTypes from '../actionTypes';

export const FETCH_ADS = actionTypes('FETCH_ADS');
export const FETCH_AD_DETAILS = actionTypes('FETCH_AD_DETAILS');
export const FETCH_ADS_SUMMARY = actionTypes('FETCH_ADS_SUMMARY');
export const SET_AD_STATUS = actionTypes('SET_AD_STATUS');
export const FETCH_AD_PRODUCTS = actionTypes('FETCH_AD_PRODUCTS');
export const SET_MULTIPLE_ADS_STATUS = actionTypes('SET_MULTIPLE_ADS_STATUS');
